import { QueryCache } from "@tanstack/react-query";
import { forceLogout } from './logout';
import { apiURL1 } from '../config';

const apiURL = apiURL1;
const queryCache = new QueryCache({
  onError: (error) => {
    // console.log(error);
  },
  onSuccess: (data) => {
    // console.log(data);
  },
});

async function client(
  endpoint,
  { data, headers: customHeaders, ...customConfig } = {}
) {
  const token = localStorage.getItem("token");
  const config = {
    method: data ? "POST" : "GET",
    body: data instanceof FormData ? data : JSON.stringify(data),
    headers: {
      Authorization: token ? `${token}` : "",
      ...(!data || data instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...customHeaders,
    },
    ...customConfig,
  };

  return await window
    .fetch(`${apiURL}/${endpoint}`, config)
    .then(async (response) => {
      if (response.status === 401) {
        queryCache.clear();
        try {
          const errorData = await response.json();
          const msg = errorData.message || 'Unauthorized';
          forceLogout('Invalid token. Please login again.');
          const error = new Error(msg);
          return Promise.reject(error);
        } catch (e) {
          forceLogout('Invalid token. Please login again.');
          return Promise.reject(new Error('Unauthorized'));
        }
      }
      if (response.ok) {
        const jsonData = await response.json();

        return jsonData;
      } else {
        const jsonData = await response.json();
        const msg = jsonData?.message || jsonData?.error;
        if (typeof msg === 'string' && msg.toLowerCase().includes('invalid token')) {
          queryCache.clear();
          forceLogout('Invalid token. Please login again.');
        }
        return Promise.reject(jsonData);
      }
    });
}

export { client };
